var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datepicker',{ref:"datePicker",class:{
    'forms-datepicker': true,
    'is-valid': _vm.state === true,
    'is-invalid': _vm.state === false,
  },attrs:{"inline":_vm.inline,"clear-button":_vm.clearButton,"input-class":"form-control","format":_vm.format,"initial-view":_vm.initialView,"open-date":_vm.openDate,"language":_vm.language,"disabled-dates":_vm.disabledDatesCombined,"disabled-dates-fct":_vm.disabledDatesFct,"disabled":_vm.disabled,"value":_vm.dateValue,"monday-first":true},on:{"selected":function($event){return _vm.emitInput($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }